export const ErrorEnumMessage = {
  // partial
  TRANSFER_DATE_BEFORE_START_DATE_CYCLE: 'ไม่สามารถจดบันทึกการย้ายกุ้งก่อนวันเริ่มรอบการเลี้ยงได้',
  PARTIAL_TRANSFER_DATE_BEFORE_TOPUP_DATE: 'ไม่สามารถทำรายการย้ายกุ้งก่อนการปล่อยกุ้งล่าสุดได้',
  PARTIAL_TRANSFER_DATE_BEFORE_LAST_TRANSFER_DATE: 'ไม่สามารถจดบันทึกการย้ายกุ้งย้อนหลังได้',
  PARTIAL_TRANSFER_DATE_AFTER_DATE_NOW: 'ไม่สามารถจดบันทึกการย้ายกุ้งวันถัดไปได้',
  CANNOT_UPDATE_PARTIAL_TRANSFER_DUE_TO_EXISTING_TRANSFER:
    'ไม่สามารถอัปเดตได้ เนื่องจากมีข้อมูลการย้ายกุ้งอยู่ก่อนหน้า',
  CANNOT_UPDATE_PARTIAL_TRANSFER: 'ไม่สามารถอัปเดตข้อมูลการย้ายกุ้งได้ เนื่องจากเป็นข้อมูลเก่า',

  // shrimp topup
  SHRIMP_TOPUP_DATE_BEFORE_TRANSFER_DATE: 'ไม่สามารถทำรายการปล่อยกุ้งก่อนการย้ายกุ้งล่าสุดได้',
  SHRIMP_TOPUP_DATE_BEFORE_START_DATE_CYCLE:
    'ไม่สามารถจดบันทึกการปล่อยกุ้งก่อนวันเริ่มรอบการเลี้ยงได้',
  SHRIMP_TOPUP_DATE_BEFORE_LAST_SHRIMP_TOPUP_DATE:
    'ไม่สามารถแก้ไขหรือลบบันทึกการปล่อยกุ้งย้อนหลังได้',
  SHRIMP_TOPUP_DATE_AFTER_DATE_NOW: 'ไม่สามารถจดบันทึกการปล่อยกุ้งวันถัดไปได้',
  CANNOT_UPDATE_SHRIMP_TOPUP: 'ไม่สามารถอัปเดตข้อมูลการปล่อยกุ้งได้ เนื่องจากเป็นข้อมูลเก่า',

  //pond
  POND_NAME_ALREADY_EXIST: 'ชื่อบ่อซ้ำ',

  // cycle
  INITIAL_SHRIMP_COUNT_UPDATE_BLOCKED_BY_PARTIAL_TRANSFER:
    'ไม่สามารถแก้ไขจำนวนลูกกุ้งเริ่มต้นเมื่อมีการย้ายกุ้ง',

  //product
  PRODUCT_NAME_DUPLICATION: 'ชื่อผลิตภัณฑ์ซ้ำกัน',
  PRODUCT_CODE_DUPLICATION: 'รหัสผลิตภัณฑ์ซ้ำกัน',
  LOT_NUMBER_DUPLICATION: 'เลขล็อตผลิตภัณฑ์ซ้ำกัน',
  STOCK_HAS_PRODUCT: 'ไม่สามารถลบผลิตภัณฑ์ได้ เนื่องจากยังมีสต๊อกที่อยู่ในผลิตภัณฑ์นี้',
  PRODUCT_DUPLICATION: 'ไม่สามารถเพิ่มผลิตภัณฑ์ เพราะมีผลิตภัณฑ์นี้อยู่ในโกดังแล้ว',

  //category
  CATEGORY_HAS_PRODUCTS: 'ไม่สามารถลบหมวดหมู่ได้ เนื่องจากยังมีผลิตภัณฑ์ที่อยู่ในหมวดหมู่นี้',
  CANNOT_DELETE_DEFAULT_CATEGORY: 'ไม่สามารถลบหมวดหมู่เริ่มต้นได้',
  CATEGORY_NAME_DUPLICATION: 'ชื่อหมวดหมู่มีการใช้แล้วในระบบ',

  //stock
  STOCK_NOT_ENOUGH: 'ปริมาณคงเหลือไม่เพียงพอ',
  DESTINATION_POND_CANNOT_MODIFY_AMOUNT: 'ไม่สามารถแก้ไขข้อมูลรอบการเลี้ยงของบ่อปลายทาง',
  CYCLE_HAS_PARTIAL_TRANSFERS: 'ไม่สามารถลบรอบเลี้ยงได้เนื่องจากมีข้อมูลย้ายกุ้งอยู่',
  CANNOT_DELETE_DESTINATION_POND_CYCLE: 'ไม่สามารถลบรอบเลี้ยงนี้ได้เนื่องจากเป็นบ่อปลายทาง',
  DESTINATION_WAREHOUSE_CLOSE_NOT_ALLOWED:
    'ไม่สามารถย้ายไปโกดังปลายทางได้ เนื่องจากคลังมีสถานะปิดอยู่',
  STOCK_NOT_FOUND: 'ไม่พบข้อมูลสต๊อกนี้',
  STOCK_IN_USE_BY_MEAL: 'สต๊อกนี้ถูกใช้งานอยู่ ไม่สามารถลบได้',
  STOCK_IN_USE_BY_MEDICINE: 'สต๊อกนี้ถูกใช้งานอยู่ ไม่สามารถลบได้',
  INVENTORY_STOCK_DUPLICATION: 'ไม่สามารถเพิ่มสต๊อกได้ เนื่องจากมีสต๊อกนี้อยู่ในคลังแล้ว',

  //iot device
  IOT_DEVICE_ALREADY_IN_USE: 'ไม่สามารถเพิ่มอุปกรณ์ได้ เนื่องจากอุปกรณ์นี้ถูกใช้งานอยู่แล้ว',
  IOT_DEVICE_DUPLICATION: 'ไม่สามารถเพิ่มอุปกรณ์ได้ เนื่องจากมีอุปกรณ์นี้อยู่ในระบบแล้ว',

  //warehouse
  WAREHOUSE_HAS_STOCK: 'ไม่สามารถลบคลังได้ เนื่องจากยังมีผลิตภัณฑ์ที่อยู่ในโกดังนี้',
  WAREHOUSE_NAME_DUPLICATION: 'ชื่อคลังนี้มีการใช้แล้วในระบบ',

  //cost
  CANNOT_DELETE_COST_TRANSACTION: 'ไม่สามารถลบรายการต้นทุนได้',
  CANNOT_UPDATE_UNIT_PRICE_DELETED_STOCK: 'ไม่สามารถแก้ไขได้เนื่องจากสต็อกนี้ถูกลบไปแล้ว',

  // credit promotion
  CREDIT_PROMOTION_NOT_FOUND: 'ไม่พบรหัสโปรโมชั่นนี้',
  CREDIT_PROMOTION_STATUS_NOT_ACTIVE: 'รหัสโปรโมชั่นหมดอายุแล้ว',
  CREDIT_PROMOTION_ALREADY_USED: 'รหัสโปรโมชั่นนี้ถูกใช้งานแล้ว',
  CREDIT_PROMOTION_GLOBAL_USAGE_LIMIT_EXCEEDED: 'รหัสโปรโมชั่นถูกใช้งานครบจำนวนแล้ว',
  INVALID_CREDIT_PROMOTION_USAGE_SCOPE: 'ไม่เป็นไปตามเงื่อนไขของโปรโมชั่น',

  // growth
  SHRIMP_GROWTH_DUPLICATION: 'ไม่สามารถบันทึกข้อมูลการเติบโตของกุ้งได้ เนื่องจากมีข้อมูลซ้ำ',
  CANNOT_DELETE_DEFAULT_SHRIMP_GROWTH: 'ไม่สามารถลบข้อมูลไซส์เริ่มต้นได้',
  CYCLE_NOT_FOUND: 'ไม่พบข้อมูลรอบการเลี้ยงของบ่อ',

  //meal / food
  STOCK_IS_REQUIRED: 'โปรดเลือกอาหารเม็ดหรืออาหารธรรมชาติอย่างน้อย 1 รายการ',
  REMAINING_FOOD_MUST_BE_POSITIVE: 'จำนวนอาหารเหลือต้องเป็นจำนวนบวก',
  REMAINING_FOOD_CANNOT_EXCEED_AMOUNT: 'จำนวนอาหารเหลือต้องไม่เกินจำนวนอาหารที่ให้',
  AMOUNT_MUST_BE_POSITIVE: 'จำนวนอาหารเม็ดต้องมากกว่า 0',
  NATURAL_AMOUNT_MUST_BE_POSITIVE: 'จำนวนอาหารธรรมชาติต้องมากกว่า 0',
  INVALID_FEEDING_TYPE: 'วิธีการให้อาหารไม่ถูกต้อง',
  INVALID_MEAL_STATUS: 'สถานะอาหารไม่ถูกต้อง',
  INVENTORY_STOCK_OUTSIDE_ORGANIZATION: 'ไม่สามารถเลือกสต๊อกที่อยู่นอกองค์กรของคุณได้',

  // feed program (total yield formula)
  PROGRAM_NAME_DUPLICATE: 'ชื่อสูตรนี้มีอยู่แล้ว',
  DUPLICATE_SHRIMP_WEIGHT: 'น้ำหนักกุ้งในสูตรซ้ำกัน',
  PROGRAM_IN_USE: 'ไม่สามารถลบสูตรได้ เนื่องจากยังมีรอบการเลี้ยงที่ใช้สูตรนี้อยู่',
  PROGRAM_DETAILS_TOO_FEW: 'กรุณากรอกสูตรอย่างน้อย 2 แถว',
  PROGRAM_DETAILS_TOO_MANY: 'กรอกสูตรได้ไม่เกิน 30 แถว',
  FORBIDDEN_SYSTEM_PROGRAM: 'ไม่สามารถแก้ไขหรือลบสูตรของระบบได้',
}
